import * as React from "react"
import * as _ from "lodash"
import { connect } from "react-redux"
import { IPatientDetail } from "@curefit/care-common";
import { IAppState } from "../models/IAppState";
import { IUnreadMsgInfoWrapper } from "../models/twilio/IUnreadMsgInfo";
import { TwilioActions } from "../actions/TwilioActions";
import { ORION_IMG_URL, AppConstants } from "../utils/AppConstants";
import AppUtils from "../utils/AppUtils";
import moment = require("moment");

export interface UnreadMessagesProps {
    unreadMessageInfo: IUnreadMsgInfoWrapper[];
    updateCurrentChannel: (channelSid: string, patient: IPatientDetail, identity: string) => void;
}

export interface UnreadMessagesState {
    messageWindow: boolean;
}

class UnreadMessages extends React.Component<UnreadMessagesProps, UnreadMessagesState> {
    private messagesDOM: any;
    constructor(props: UnreadMessagesProps) {
        super(props);
        this.state = {
            messageWindow: false
        }
    }
    calculateTotalUnreadCount = () => {
        let count = 0;
        _.map(this.props.unreadMessageInfo, (unreadMessage: IUnreadMsgInfoWrapper) => {
            count += unreadMessage.twilioUnreadMessageCountView.unreadMessageCount;
        })
        return count;
    }
    toggleMessageWindow = () => {
        let myInstance = this;
        myInstance.setState({
            messageWindow: !myInstance.state.messageWindow
        }, () => {
            if (myInstance.state.messageWindow) myInstance.messagesDOM.focus();
        })
    }
    setCurrentChannel = (channelSid: string, patient: IPatientDetail, identity: string) => {
        this.props.updateCurrentChannel(channelSid, patient, identity);
    }
    getMessageRecievedTime(receivedTimeStamp: number): string {
        const todayDateEpoch = new Date().setHours(0, 0, 0, 0);
        const receivedEpoch = new Date(receivedTimeStamp).setHours(0, 0, 0, 0);
        if (todayDateEpoch === receivedEpoch) {
            return moment(receivedTimeStamp).format("HH:mm");
        } else {
            return `${Math.floor((new Date().getTime() - receivedTimeStamp) / AppConstants.EPOCH_MS_IN_ONE_DAY)} days ago`;
        }
    }


    render() {
        let unreadMsgCount = !_.isEmpty(this.props.unreadMessageInfo) ? this.calculateTotalUnreadCount() : null;
        let unreadMessages = this.props.unreadMessageInfo;
        let showMessagesWindow = this.state.messageWindow;
        let isMobile = AppUtils.getIsMobile();
        return (
            <div className="top-right-nav">
                <div className="chat-div">
                    <img src={ORION_IMG_URL + "chat-icon.svg"} onClick={this.toggleMessageWindow} />
                    {
                        unreadMsgCount &&
                        <div className={`unread-count-badge`}>{unreadMsgCount > 99 ? "99+" : unreadMsgCount}</div>
                    }
                    {
                        showMessagesWindow &&
                        <div ref={(messagesDOM) => this.messagesDOM = messagesDOM} className={"top-nav-messages-container"} onClick={!isMobile ? this.toggleMessageWindow : () => { }} tabIndex={0} onBlur={this.toggleMessageWindow}>
                            {!isMobile &&
                                <div className={"brandon-bold messages-label"}>Messages</div>
                            }
                            {isMobile &&
                                <div className={"brandon-bold messages-label"}>
                                    <span>Messages</span>
                                    {unreadMsgCount &&
                                        <span className="unread-count-label">{unreadMsgCount > 99 ? "99+" : unreadMsgCount}</span>
                                    }
                                    <span className="close-chat" onClick={this.toggleMessageWindow}>x</span>
                                </div>
                            }
                            {Array.isArray(unreadMessages) && unreadMessages.length > 0 ?
                                _.map(unreadMessages, (messageInfo, index) => {
                                    let unreadMessageObject = messageInfo.twilioUnreadMessageCountView;
                                    let cssClass = unreadMessageObject.unreadMessageCount > 0 ? "unread" : "";
                                    let lastMessageCss = _.isEmpty(unreadMessageObject.lastMessageText) ? "attachment" : "";
                                    if (!_.isEmpty(messageInfo.patient.name)) {
                                        return <a className={`message-card ${cssClass}`} key={`message-card-${index}`} tabIndex={0} onMouseDown={(e) => this.setCurrentChannel(messageInfo.twilioUnreadMessageCountView.channelSid, messageInfo.patient, messageInfo.twilioUnreadMessageCountView.memberIdentity)}>
                                            <div className={"name-card"}><div className="name-initial">{messageInfo.patient.name[0].toUpperCase()}</div></div>
                                            <div className={"content-card"}>
                                                <div className={"patient-name"}>
                                                    <span>{messageInfo.patient.name} {unreadMessageObject.unreadMessageCount !== 0 ? `(${unreadMessageObject.unreadMessageCount})` : ""}</span>
                                                    {isMobile &&
                                                        <div className="message-meta">
                                                            <div className="unread-dot"></div>
                                                            <div className="time">{this.getMessageRecievedTime(messageInfo.twilioUnreadMessageCountView.lastMessageTimestamp)}</div>
                                                        </div>
                                                    }
                                                </div>
                                                <div className={`last-conversation ${lastMessageCss}`}>{!_.isEmpty(unreadMessageObject.lastMessageText) ? unreadMessageObject.lastMessageText : "[ ATTACHMENT ]"}</div>

                                            </div>
                                        </a>
                                    }
                                })
                                :
                                <span className="no-active-chat">{"No Active Chats"}</span>
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = function (state: IAppState) {
    return {
        unreadMessageInfo: state.twilioContext.unreadMessageInfo
    }
}

const mapDispatchToProps = function (dispatch: any) {
    return {
        updateCurrentChannel: (channelSid: string, patient: IPatientDetail, identity: string) => {
            return dispatch(TwilioActions.updateCurrentChannelWithPatient(channelSid, patient, identity));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UnreadMessages);